import React from 'react'
import {_L, useLocaleState} from '../../../context/LocaleContext'
import styled from 'styled-components'
import Icons from '../../Icons'
import {
  StyledContainer,
  StyledItem,
  StyledIcon,
  StyledImage,
  LinkWrapper
} from './StyledSearchResult'
import Avatar from '../../Avatar/Avatar'

const ResultContainer = styled.ul`
  height: calc(100% - 10px);
  margin-top: 10px;
  padding-left: 5px;
  padding-right: 5px;
  
  @media (max-width: 420px) {
    height: calc(100vh - 300px);
  }
`

const RoomResult = ({rooms, onItemClick, isSmall}) => {
  const localeState = useLocaleState()
  let roomsFiltered = rooms
  return (
    <ResultContainer id="room-list" role="group">
      {roomsFiltered.map(rm => {
        let roomTitle = rm['rm.name'] ? rm['rm.name'] : rm['rm.rmTypeDescription']
        const roomName = ` - ` + roomTitle
        const department = rm['rm.department'] ? rm['rm.department'] : ''
        const {image_url} = {}
        let item = {
          blId: rm['rm.bl_id'],
          flId: rm['rm.fl_id'],
          rmId: rm['rm.rm_id'],
          rm
        }
        let nextItem = null
        let previousItem = null
        let parentItem = null
        let nextTabItem = null
        const onRmItemKeyDown = evt => {
    	    if (evt) {
    	    	evt.preventDefault()
    		}
    	    parentItem= evt.target.parentElement.parentElement   
    	    if(evt.key == "Enter" || evt.key == " " || !evt.key){
    	    	onItemClick({type: 'rm', item, evt})
    	    }
    	    if(evt.key == "End"){ 
    	    	document.querySelectorAll('[aria-owns$="list"]')[document.querySelectorAll('[aria-owns$="list"]').length - 1].focus()
    	    }
    	    if(evt.key == "Home"){ 
    	    	document.querySelectorAll('[aria-owns$="list"]')[0].focus()
    	    }
    	    if(evt.key == "ArrowLeft"){
    	    	document.querySelector('[aria-owns="' + parentItem.id + '"]').focus()
    	    }
    	    if(evt.key == "ArrowDown"){
    	    	nextItem = evt.target.parentElement.nextSibling
    	    	nextTabItem = document.querySelector('[aria-owns="' + parentItem.id + '"]').parentElement.nextSibling
    	    	if(nextItem != null) {
    	    		nextItem.firstChild.focus()
    	    	}else if(nextTabItem != null){
    	    		nextTabItem.firstChild.focus()
    	    	}
    	    }
    	    if(evt.key == "ArrowUp"){
    	    	previousItem = evt.target.parentElement.previousSibling
    	    	if(previousItem != null) {
    	    		previousItem.firstChild.focus()
    	    	}else{
    	    		document.querySelector('[aria-owns="' + parentItem.id + '"]').focus()
    	    	}
    	    }
    	    if(evt.key == "Escape"){ 
    	    	document.getElementById("search-input").focus()
    	    }
    	    if(evt.key == "Tab"){
    	    	document.getElementById("search-input").focus()
    	    }
        }
        return (
          <StyledContainer
            key={rm['rm.roomkey']}
            role="none"
          >
            <LinkWrapper
            	role="treeitem"
            	tabIndex="-1"
            	onClick={evt => onItemClick({type: 'rm', item, evt})}
            	onKeyDown={onRmItemKeyDown}
            >
	            <StyledImage isSmall={isSmall}>
	              <Avatar url={image_url} large type="building" />
	            </StyledImage>
	            <StyledItem isBold gridRow="1" gridColumn={isSmall ? '2 /span 4 ': '2 /span 2'}>
	              {rm['rm.rm_id'] + roomName}
	            </StyledItem>
	            <StyledItem 
	            	gridRow={isSmall ? '3' : '2' }
	            	gridColumn={isSmall ? '2 /span 4 ': '2 /span 2'}
	            >
		          {rm['rm.category']}
		        </StyledItem>
	            <StyledItem
	                gridRow={isSmall ? '4' : '1'}
	                gridColumn={isSmall ? '2 /span 4' : '4 /span 2'}
	                color="#52555B"
	            >
	            {rm['rm.building']} [{rm['rm.bl_id']}] - Floor {rm['rm.fl_id']}
	            </StyledItem>
	            <StyledItem
	              gridRow={isSmall ? '5' : '2'}
	              gridColumn={isSmall ? '2 /span 4' : '4 /span 2'}
	              color="#52555B"
	            >
	            {department}
	            </StyledItem>
	         </LinkWrapper>
          </StyledContainer>
        )
      })}
    </ResultContainer>
  )
}

export default RoomResult
